export const S3_URL = "https://d26whlelwrmtms.cloudfront.net" 
export const POLL_DELAY_MS = 5000;
export const DEFAULT_VIDEO_STREAM = "https://d26whlelwrmtms.cloudfront.net/demo/first-demo/media/hls/720p30/playlist.m3u8";
